import type { Comp } from "kaplay";
import { config } from "../config";
import { on } from "../core/events";
import type { RunState } from "../core/runState";
import { SCORING_EVENTS, applyEvent, tick, type ScoringEvent } from "../systems/scoring";

export function scoreKeeper(run: RunState): Comp {
    const { distanceScore } = config.modes.modes[run.mode];
    let lastDistance = run.distanceM;

    return {
        id: "scoreKeeper",
        add() {
            for (const name of SCORING_EVENTS) {
                on(name, (payload) => Object.assign(run, applyEvent(run, { name, payload } as ScoringEvent, config.scoring)));
            }
        },
        update() {
            Object.assign(run, tick(run, run.speed, run.distanceM - lastDistance, distanceScore, config.scoring));
            lastDistance = run.distanceM;
        },
    };
}
